const VALID_LOCALES = [
    "br",
    "de",
    "en",
    "es",
    "fr",
    "hu",
    "it",
    "ja",
    "ko",
    "nl",
    "pl",
    "ru",
    "zh"
] as const;

type ExtractTypeFromArray<T extends Iterable<unknown>> = T extends Iterable<
    infer E
>
    ? E
    : never;

export type SupportedLocales = ExtractTypeFromArray<typeof VALID_LOCALES>;

export const isValidLocale = (locale: string): locale is SupportedLocales =>
    VALID_LOCALES.includes(locale as SupportedLocales);

export const isEqualUnlocalizedPathname = (
    pathname_a: string,
    pathname_b: string
) => {
    if (!pathname_a || !pathname_b) {
        return false;
    }

    const regex = new RegExp(`^/(${VALID_LOCALES.join("|")})`);
    const a = pathname_a.replace(regex, "");
    const b = pathname_b.replace(regex, "");

    return a === b;
};
